import React from 'react';
import MyProgress from '../Dashboard/MyProgress/MyProgress';
import UserInfo from '../Dashboard/UserInfo/UserInfo';
import MyOolaScore from '../Dashboard/MyOolaScore/MyOolaScore';
import MarketingTrackerPreview from './MarketingTrackerPreview';
import MarketingGoalsPreview from './MarketingGoalsPreview';
import MarketingProductionTracker from './MarketingProductionTracker';
import MarketingProductionGoals from './MarketingProductionGoals';
import MarketingELearningBoardPreview from './MarketingELearningBoardPreview';
import MarketingHeader from './MarketingHeader';
import MarketingMobileHeader from './MarketingMobileHeader';
import { demoDashboardState, MARKETING_PROFILE_IMAGE_URL } from './marketingDemoData';
import '../Dashboard.css';
import './MarketingAssets.css';

/**
 * Full V1 dashboard composition for marketing captures.
 * Reuses MyProgress, UserInfo (PublicProfile), MyOolaScore + static tracker/goals/e-learning.
 */
const MarketingDashboardPreview = ({
    trackerTab = 'daily',
    showOolaScore = true,
    showElearning = true,
    showTracker = true,
    showGoals = true,
    production = false,
    variant = 'desktop',
    className = '',
}) => {
    const isMobile = variant === 'mobile';
    const Header = isMobile ? MarketingMobileHeader : MarketingHeader;
    const TrackerPanel = production ? (
        <MarketingProductionTracker initialTab={trackerTab} />
    ) : (
        <MarketingTrackerPreview activeTab={trackerTab} />
    );
    const GoalsPanel = production ? (
        <MarketingProductionGoals />
    ) : (
        <MarketingGoalsPreview />
    );

    return (
    <div
        className={`marketing-v1-shell Dashboard__container${
            isMobile ? ' marketing-v1-shell--mobile' : ''
        } ${className}`.trim()}
    >
        <Header />
        <section className="dashboard">
            <div className="DashboardSection1">
                <div className="DashboardSection11">
                    <UserInfo
                        AllState={demoDashboardState}
                        AllStateChange={() => {}}
                        getCustomerProfileInformation={() => {}}
                        achievementsLoading={false}
                        PublicProfile={1}
                        profileImageUrl={MARKETING_PROFILE_IMAGE_URL}
                    />
                    <MyProgress
                        AllState={demoDashboardState}
                        AllStateChange={() => {}}
                        myProgressLoading={false}
                    />
                </div>
            </div>
            <div className="DashboardSection2">
                <div className="DashboardSection21">
                    {showTracker ? TrackerPanel : null}
                    {showGoals ? GoalsPanel : null}
                    {showOolaScore ? (
                        <div className="MyOolaScoreCell__container">
                            <MyOolaScore
                                AllState={demoDashboardState}
                                AllStateChange={() => {}}
                                currBadget={null}
                            />
                        </div>
                    ) : null}
                </div>
                {showElearning ? (
                    <div className="DashboardSection22">
                        <MarketingELearningBoardPreview />
                    </div>
                ) : null}
            </div>
        </section>
    </div>
    );
};

export default MarketingDashboardPreview;
